export default __webpack_public_path__ + "static/media/1907.60c8b7e0.png";